export const URLVALUES = {
  approvedLiveningInspector:
    "https://www.vector.co.nz/personal/electricity/approved-livening-inspector",
};
